var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPauseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 11.3333H14.6666C13.9302 11.3333 13.3333 11.9302 13.3333 12.6666V23.3333C13.3333 24.0696 13.9302 24.6666 14.6666 24.6666H15.9999C16.7363 24.6666 17.3333 24.0696 17.3333 23.3333V12.6666C17.3333 11.9302 16.7363 11.3333 15.9999 11.3333ZM21.3333 11.3333H19.9999C19.2635 11.3333 18.6666 11.9302 18.6666 12.6666V23.3333C18.6666 24.0696 19.2635 24.6666 19.9999 24.6666H21.3333C22.0696 24.6666 22.6666 24.0696 22.6666 23.3333V12.6666C22.6666 11.9302 22.0696 11.3333 21.3333 11.3333ZM14.6666 12.6666V23.3333H15.9999V12.6666H14.6666ZM19.9999 23.3333V12.6666H21.3333V23.3333H19.9999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPauseCircle);
export default __webpack_public_path__ + "static/media/icon_pause_circle.9d7af037.svg";
export { ForwardRef as ReactComponent };